
@if (view.site && view.site.profile && view.site.profile.pages) {
    @switch (view.site.profile.pages.about) {
        @case (1) {
            <app-about-type01></app-about-type01>
            }
        @case (2) {
            <app-about-type02></app-about-type02>
            }
        @case (3) {
            <app-about-type03></app-about-type03>
            }
        @case (4) {
            <app-about-type04></app-about-type04>
        }
        @case (5) {
            <app-about-type05 class="w-full"></app-about-type05>
        }
    }
}